<script lang="ts">
import { reactive, defineComponent, ref } from '@vue/composition-api';
import { confirm, snackbar } from '@/_core/app-components/use';
import { commandDispatcher } from '@/_core/cqrs';
import { DeleteUserAccountCommand } from '@/api/account/commands';
import { goToLogout } from '@/_core/utils/navigation';
import { trackingService } from '@/_core/tracking/trackingService';
import { TrackAccountDeleted } from '@/_core/tracking/userActionsToTrack/user/trackAccountDeleted';

const DeleteAccount = defineComponent({
    name: 'DeleteAccount',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const state = reactive({
            isConfirmed: false,

            message: '',
        });

        const deleting = ref(false);

        const deleteAccount = async () => {
            const res = await commandDispatcher.dispatchCommand(new DeleteUserAccountCommand());
            if (res.IsSuccess) {
                trackingService.TrackUserAction(new TrackAccountDeleted());
                goToLogout();
            } else {
                let message = '';
                if (res.Workspaces != null) {
                    message = `Can't delete your account because you are the only subscription admin for the following workspace(s): ${res.Workspaces}. 
                      Please give subscription admin role for other members on these workspaces or delete them.`;
                } else if (res.Domains != null) {
                    message = `Can't delete your account because you are the only domain admin for the following domain(s): ${res.Domains}. 
                    Please add other domain admins to these domains or delete them.`;
                }
                snackbar.showError('Can not delete!');
                state.message = message;
            }
        };
        const onDeletAccount = async () => {
            confirm.show({
                title: 'Delete your account?',
                message: 'This is the last chance to change your mind. Are you sure you want to delete your account?',
                acceptBtnText: 'Delete account',
                cancelBtnText: 'Cancel',
                width: 500,
                acceptFn: async () => {
                    deleting.value = true;
                    try {
                        await deleteAccount();
                    } finally {
                        deleting.value = false;
                    }
                },
            });
        };

        return {
            state,
            deleting,
            onDeletAccount,
        };
    },
});

export default DeleteAccount;
</script>

<template>
  <v-card flat class="pt-2 d-flex flex-column">
    <v-progress-linear
      :active="deleting"
      indeterminate
      color="error lighten-2"
      class="mt-1"
    />

    <v-card-text>
      <v-alert
        type="info"
        text
        dense
        :value="true"
      >
        By deleting your account, your membership will also be canceled in all workspaces where you are a member.
      </v-alert>

      <!-- <v-alert
        type="warning"
        :value="true"
        text
        dense
        class="mt-12"
      >
        <span class="text-uppercase">THIS OPERATION CANNOT BE UNDONE!</span>
      </v-alert> -->

      <AppWarning>
        THIS OPERATION CANNOT BE UNDONE!
      </AppWarning>

      <v-alert
        v-if="state.message"
        type="error"
        :value="true"
        text
        dense
      >
        {{ state.message }}
      </v-alert>

      <v-checkbox
        v-model="state.isConfirmed"
        :disabled="deleting"
        label="I understand, please delete my account."
        class="mt-2"
      />
    </v-card-text>

    <v-card-actions class="pt-0 ">
      <v-btn
        color="error"
        x-large
        :loading="deleting"
        :disabled="!state.isConfirmed"
        @click="onDeletAccount"
      >
        <v-icon left>
          $fasUserTimes
        </v-icon>
        Delete your account
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="sass" scoped></style>
